import { Component, inject } from '@angular/core';
import { MotifModalModule, MotifModalRef } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-confirm-stop',
  standalone: true,
  imports: [MotifModalModule],
  templateUrl: './confirm-stop.component.html',
  styleUrls: ['./confirm-stop.component.scss']
})
export class ConfirmStopComponent {
  readonly dialogRef = inject(MotifModalRef<ConfirmStopComponent>);
}
